import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import TopNavbar from '@/layout/components/topNavbar/TopNavbar.vue';
import ContentFooter from '@/layout/components/ContentFooter.vue';
import vLoaderAnimation from '@/components/template/v-loader-animation.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';


export default /*@__PURE__*/_defineComponent({
  __name: 'IrregularLayout',
  setup(__props) {

const { isAuthenticated, loading } = useAuth();


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (!_unref(loading) && _unref(isAuthenticated))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(TopNavbar, { hideNoticeIcon: true }),
        _createVNode(_component_router_view),
        _createVNode(ContentFooter)
      ], 64))
    : _createCommentVNode("", true)
}
}

})